import { render, staticRenderFns } from "./Wdetail.vue?vue&type=template&id=2edaac1a&scoped=true"
import script from "./Wdetail.vue?vue&type=script&lang=js"
export * from "./Wdetail.vue?vue&type=script&lang=js"
import style0 from "./Wdetail.vue?vue&type=style&index=0&id=2edaac1a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2edaac1a",
  null
  
)

export default component.exports